export enum LexonApiCodeCatalog {
  INVALID_USER_PASS = 'ERR00000',
  INVALID_PARTNER_ID = 'ERR00001',
  INVALID_AUTH_TOKEN = 'ERR00002',
  EMPTY_FIELD = 'ERR00003',
  EXPIRED_TOKEN = 'ERR00004',
  INVALID_TOKEN = 'ERR00005',
  FORBIDDEN_COMPANY = 'ERR00006',
  INVALID_PASSWORD = 'ERR00007',
  MC_LOGIN_ERROR = 'ERR00008',
  MC_LOGIN_USER_NOT_FOUND = 'ERR00009',
  MC_LOGIN_USER_INACTIVE = 'ERR00010',
  MC_LOGIN_LEXON_INACTIVE = 'ERR00011',
  INVALID_PARTNER_ID_CLAIM = 'ERR00012',
  USER_PRO_ID_NOT_FOUND = 'ERR000013',
  PORTAL_USER_INACTIVE = 'ERR000014',
  INVALID_SESSION = 'ERR000015',
  UNASSIGNED_COMPANY = 'ERR000016',
  LEXON_USER_BLOCKED = 'ERR000017',
  INVALID_PRODUCT_CONFIG = 'ERR000018',
  COMPANY_CONNECTION_FAILED = 'ERR000019',
  FIELD_MUST_BE_NULL = 'ERR000020',
  NO_CONTENT_FILE = 'ERR000021',
}
